import './DeparturesFiltersFooter.scss';

import { useApplyFilters } from "../../../../hooks/useApplyFilters";

import { Button } from "../../../../common-components/Buttons/Buttons";

const DeparturesFiltersFooter = () => {
    const componentId = "departures";
    const { applyFiltersParams } = useApplyFilters({componentId});

    return (
        <div className={"departures-filters-footer"}>
            <div className={"departures-filters-footer_container"}>
                <div className={"departures-filters-footer_buttons"}>
                    <Button title={"Применить"} onClick={applyFiltersParams}/>
                </div>
            </div>
        </div>
    )
}

export default DeparturesFiltersFooter;